import React, { View } from 'react-native'
import { useNavigation } from '@react-navigation/native'
import { useSelector } from 'react-redux'
import { StyleService, useStyleSheet } from '@src/style/service'
import { NavigationCard } from '@src/navigation/components/NavigationCard'
import { referralCreditsSelector } from '@src/selectors/app'
import { Text } from '@src/components/base'
import { useActiveCoreSubscription } from '@src/hooks/useActiveSubscriptions'
import { useLazyScreenPreload } from '@src/navigation/utils'
import { redirectToWriteReview } from '@src/utils/store'
import { Feature, useFeatureFlag } from '@components'

export const ProfileContentGrid = () => {
  const navigation = useNavigation()
  const styles = useStyleSheet(themedStyles)
  const referralCredits = useSelector(referralCreditsSelector)
  const newRatingsEnabled = useFeatureFlag(Feature.NewRatings)

  const coreSubscription = useActiveCoreSubscription()

  useLazyScreenPreload('ManageSubscriptions', { shouldPreload: !!coreSubscription?.id })

  const handleManageSubscriptionPress = () => {
    if (coreSubscription?.id) {
      navigation.navigate('ManageSubscriptions')
    } else {
      navigation.navigate('Subscriptions')
    }
  }

  const handleProgramsPress = () => {
    navigation.navigate('Subscriptions')
  }

  const handleAccountPasswordPress = () => {
    navigation.navigate('ChangePassword')
  }

  const handleReferAFriendPress = () => {
    navigation.navigate('FriendReferral', { source: 'Account' })
  }

  const handleSettingsPress = () => {
    navigation.navigate('AppSettings')
  }

  const gridPlaceholder = <View style={styles.textGrow} />

  return (
    <View style={styles.grid}>
      <View style={styles.gridRow}>
        <NavigationCard
          title="Programs & Add-ons"
          onPress={handleProgramsPress}
          iconName="shopping-cart"
        />
        <NavigationCard
          title="Account Password"
          onPress={handleAccountPasswordPress}
          iconName="lock-simple"
        />
      </View>
      <View style={styles.gridRow}>
        <NavigationCard
          title="Manage Subscription"
          onPress={handleManageSubscriptionPress}
          iconName="credit-card"
        />
        <NavigationCard
          title="Refer a Friend"
          onPress={handleReferAFriendPress}
          pill={
            referralCredits > 0 ? (
              <View style={styles.referralPill}>
                <Text type="small" bold style={styles.pillText}>{`GET $${referralCredits}`}</Text>
              </View>
            ) : undefined
          }
          iconName="gift"
        />
      </View>
      <View style={styles.gridRow}>
        {!newRatingsEnabled && (
          <NavigationCard title="Leave a Review" onPress={redirectToWriteReview} iconName="star" />
        )}
        <NavigationCard title="Settings" onPress={handleSettingsPress} iconName="gear" />
        {newRatingsEnabled && gridPlaceholder}
      </View>
    </View>
  )
}

const themedStyles = StyleService.create({
  grid: {
    paddingHorizontal: 16,
    marginBottom: 16,
    gap: 8,
  },
  gridRow: {
    gap: 8,
    flexDirection: 'row',
  },
  referralPill: {
    height: 24,
    borderRadius: 100,
    backgroundColor: 'theme.like',
    paddingTop: 2,
    paddingHorizontal: 12,
    marginLeft: 8,
    justifyContent: 'center',
    flexShrink: 0,
  },
  pillText: {
    color: 'theme.solid.white',
  },
  textGrow: {
    flex: 1,
  },
  optedIn: {
    marginTop: 4,
    color: 'theme.success.darkest',
  },
  optedOut: {
    marginTop: 4,
    color: 'theme.disabled.text',
  },
})
